<div *ngIf="currentDataService.Data">
<h3>Define a Global Secondary Index for the table</h3>
<mat-form-field>
    <mat-label>Primary Key</mat-label>
    <mat-select  [(ngModel)]="primaryKey" required name="primaryKey">
    <mat-option *ngFor="let column of currentDataService.columns" [value]="column">
        {{column}}
    </mat-option>
    </mat-select>        
</mat-form-field>

<mat-form-field>
    <mat-label>Sort Key</mat-label>
    <mat-select [(ngModel)]="sortKey" name="sortKey">
    <mat-option value="">None</mat-option>
    <mat-option *ngFor="let column of currentDataService.columns" [value]="column">
        {{column}}
    </mat-option>
    </mat-select>
</mat-form-field>
<app-query-run [runConfig]="run" 
*ngFor="let run of currentDataService.Config?.runs"
[primaryKey]="primaryKey" [sortKey]="sortKey"
[SolutionRequested]="SolutionRequested"></app-query-run>
</div>
